import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { Link } from '../link';
import { FontFamily } from '../typography';
import { breakpoint } from '../grid';

class SeoBreadcrumbs extends PureComponent {
    static propTypes = {
        links: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string,
                text: PropTypes.string.isRequired,
                image: PropTypes.string,
            })
        ),
        onClickSeoBreadcrumb: PropTypes.func,
    };

    static defaultProps = {
        onClickSeoBreadcrumb: noop,
    };

    render() {
        const { links, onClickSeoBreadcrumb, ...props } = this.props;

        return (
            <div
                itemScope
                itemType="http://schema.org/BreadcrumbList"
                {...props}
            >
                <meta
                    content={links ? links.length : ''}
                    itemProp="numberOfItems"
                />
                {links.map(this.renderBreadcrumb)}
            </div>
        );
    }

    onClickSeoBreadcrumb = e => {
        if (e.currentTarget.href) {
            this.props.onClickSeoBreadcrumb(e, e.currentTarget.href);
        }
    };

    renderBreadcrumb = (link, index, links) => {
        const Item = link.url && index !== links.length - 1 ? Link : 'span';
        const key = `${link.url}__${link.text}`;
        return [
            (
                <BreadcrumbContainer
                    key={key}
                    itemProp="itemListElement"
                    itemScope
                    itemType="http://schema.org/ListItem"
                >
                    <meta
                        content={index + 1}
                        itemProp="position"
                    />
                    <Item
                        href={link.url}
                        itemProp="item"
                        itemScope
                        itemType="http://schema.org/Thing"
                        onClick={this.onClickSeoBreadcrumb}
                    >
                        <meta
                            content={link.image}
                            itemProp="image"
                        />
                        <span itemProp="name">{link.text}</span>
                    </Item>
                </BreadcrumbContainer>
            ),

            index !== links.length - 1 && (
                <Divider key={`${key}__separator`}>{arrow}</Divider>
            ),
        ];
    }
}

const arrow = String.fromCharCode(8250);

const BreadcrumbContainer = styled.span`
    font-size: 13px;
    font-family: ${FontFamily.SharpSansSemibold};
    line-height: 20px;

    ${breakpoint.medium} {
        font-size: 15px;
    }
`;

const Divider = styled(BreadcrumbContainer)`
    padding-left: 6px;
    padding-right: 6px;
`;

export { SeoBreadcrumbs };
